// extracted by mini-css-extract-plugin
export default {"header":"Home_header__+Ebc8","sectionOne":"Home_sectionOne__NWibM","sectionTwo":"Home_sectionTwo__N4swe","footer":"Home_footer__IZilu"};